import {
  returnData,
  apiClientVersioned,
  type IPaginatedResponse,
} from '../index'

import type { IUploadedFile } from '../types/file'

export const FilesApi = {
  getSignedUrl: (url: string) =>
    returnData(
      apiClientVersioned.get<{ url: string }>(
        `files/download-url?url=${encodeURIComponent(url)}`,
      ),
    ),
  getFile: (fileId: string) =>
    returnData(apiClientVersioned.get<IUploadedFile>(`files/${fileId}`)),
  /** Raw bytes of a storage-backed chat file, proxied same-origin (any content type, despite the route name). */
  getFileContent: (fileId: string) =>
    returnData(
      apiClientVersioned.get<Blob>(
        `files/${fileId}/spreadsheet-preview-source`,
        { responseType: 'blob' },
      ),
    ),
  /** Files the authenticated user owns, created within the given Unix timestamps. */
  listOwn: (params: {
    created_at_from: number
    created_at_to: number
    size: number
  }) =>
    returnData(
      apiClientVersioned.get<IPaginatedResponse<IUploadedFile>>('files', {
        params,
      }),
    ),
}
